import { type FC } from 'react';
import type { FormErrorMessageProps } from './types';
import { FormErrorMessage as ChakraUiFormErrorMessage } from '@chakra-ui/react';
import { BODY_CONFIG } from '@/components/Typography';

export const FormErrorMessage: FC<FormErrorMessageProps> = ({ children, ...props }) => {
  return (
    <ChakraUiFormErrorMessage
      sx={{...BODY_CONFIG.Default10}}
      {...props}
    >
      {children}
    </ChakraUiFormErrorMessage>
  )
}